package com.bikompanion.data

import kotlinx.serialization.Serializable

@Serializable
data class CityBikesNetworkDetailResponse(
    val network: CityBikesNetworkDetailDto,
)
